import axios from '@/api/createApi'
/**
 *
 *
 * 根 actions
 *
 */
export default {
    /**
     * 获取用户信息
     */
    getUserInfo: async ({ commit }) => {
        try {
            const { code, data } = await axios({
                url: 'user/getUserInfo',
                method: 'get',
                params: null,
                baseURL: process.env.VUE_APP_ADPTER_API
            })
            if (code === 200) {
                commit('updateRootStateData', { key: 'user_info', value: data })
            }
        } catch (error) {
            // 错误信息
        }
    },
}
